import { render, staticRenderFns } from "./ptsp.vue?vue&type=template&id=37b8931a&scoped=true"
import script from "./ptsp.vue?vue&type=script&lang=js"
export * from "./ptsp.vue?vue&type=script&lang=js"
import style0 from "./ptsp.vue?vue&type=style&index=0&id=37b8931a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b8931a",
  null
  
)

export default component.exports